import { NextSeo } from 'next-seo';
import React from 'react';
import TheRafflePage from '../../components/TheRafflePage';
import config from '../../config';
import firebase from '../../firebase';

function RafflesPage({ raffle }) {
  const description = ``;

  raffle.startDate = new Date(raffle.startDate);
  raffle.endDate = new Date(raffle.endDate);

  return (
    <>
      <NextSeo title={`Raffle: ${raffle.name} - ${config.siteName}`} description={description} />

      <div className='mt-10 mb-20'>
        <TheRafflePage raffle={raffle} />
      </div>
    </>
  );
}

export async function getServerSideProps({ params }) {
  const { id } = params;

  const ref = await firebase.firestore().collection('raffles').doc(id).get();
  const raffle = ref.data();

  return {
    props: {
      raffle: {
        ...raffle,
        startDate: raffle.startDate.toDate().toString(),
        endDate: raffle.endDate.toDate().toString(),
      },
    },
  };
}

export default RafflesPage;
